var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Display'),_c('div',{staticClass:"main-content"},[_c('Advertise'),_c('Monetize'),_c('AdUnits'),_c('Games'),_c('About')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }